export function usesDepository(provider) {
    return provider.funding === 'depository';
}
export function depositMethodForFunding(funding) {
    return funding === 'depository' ? 'wallet' : 'deposit_address';
}
export function requiredDepositMethod(provider) {
    return depositMethodForFunding(provider.funding);
}
/**
 * Destination-side semantics (no v1 provider, designed for later):
 * an extended destination D maps to real destination R; the backend swap
 * delivers to the user's own address on R, then a provider-supplied
 * completion-step component executes the post-hop (e.g. deposit into a
 * destination protocol's contract). The registry/quote/creation seams branch by `direction`, so adding
 * it later means a new provider + one completion-step dispatch.
 */
